module.exports = __webpack_public_path__ + "img/11.0ea47735.jpg";